"use client";

import { useSession } from "next-auth/react";
import { useEffect } from "react";

export function GTMUserTracker() {
    const { data, status } = useSession();

    const userRole = data?.user.role || "Guest";
    const userId = data?.user?.userID.toString();

    useEffect(() => {
        if (status === "loading") {
            return; // Do nothing while the session is still loading
        }

        const timer = setTimeout(() => {
            window.dataLayer ||= [];
            window.dataLayer.push({
                kss_role: userRole
            });
            if (userId) {
                window.dataLayer.push({
                    user_id: userId
                });
            }
        }, 0);

        return () => clearTimeout(timer);
    }, [userRole, userId, status]);

    return null;
}
